/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInLimitSnapshotStatus = typeof LinkedInLimitSnapshotStatus[keyof typeof LinkedInLimitSnapshotStatus];


export const LinkedInLimitSnapshotStatus = {
  ok: 'ok',
  warning: 'warning',
  critical: 'critical',
} as const;
